<template>
  <div class="newsFlex">
    <div class="flexItem">
      <router-link
        v-for="(news, index) of this.newsList"
        :key="index"
        class="newsItem flex"
        :to="{path:'/newsdetail', query:{id:news.id}}"
      >
        <img :src="news.img" class="pic" />
        <div class="flexItem">
          <h6>{{ news.title }}</h6>
          <div class="desc">
            {{ news.desc }}
          </div>
          <div class="date">{{ news.date }} &nbsp; 浏览量 {{ news.read }}</div>
        </div>
      </router-link>
      <div class="pager">
        <div class="layui-laypage">
          <button @click="firstPage" :disabled="this.currentPage == 1">首页</button>
          <button @click="previousPage" :disabled="this.currentPage == 1">上页</button>
          <button @click="nextPage" :disabled="this.currentPage >= this.pageCount">下页</button>
          <button @click="lastPage" :disabled="this.currentPage >= this.pageCount">尾页</button>
        </div>
      </div>
    </div>
    <div class="classTJ">
      <div class="TuijianTitle">推荐课程</div>
      <router-link
        v-for="(course, index) of this.courseList"
        :key="index"
        :to="{path:'/coursedetail', query:{'id':course.id}}"
        class="TuijianItem"
      >
        <img :src="course.cover" class="avatar" />
        <span class="name">{{ course.name }}</span>
        <span class="desc"
          >共{{ course.videoTotalCount }}节课 ｜ 学分：{{
            course.credit
          }}分</span
        >
      </router-link>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "../../server/news_center_list";
import { getRecommendCourse } from "../../server/index_main_recommend";

export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      newsList: [],
      courseList: [],
    };
  },
  mounted() {
    this.fetchNewsCenterData(this.currentPage);
  },
  methods: {
    async fetchNewsCenterData(pageIndex) {
      let newsResult = await getNewsList(pageIndex);
      this.total = newsResult.total;
      this.newsList = newsResult.news;
      let courseResult = await getRecommendCourse();
      this.courseList = courseResult.list;
    },
    firstPage() {
      this.currentPage = 1;
    },
    previousPage() {
      this.currentPage -= 1;
    },
    nextPage() {
      this.currentPage += 1;
    },
    lastPage() {
      this.currentPage = this.pageCount;
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.fetchNewsCenterData(this.currentPage);
      },
    },
  },
  computed: {
    pageCount: {
      get() {
        if (this.total % 10 == 0) {
          return parseInt(this.total / 10);
        } else {
          return parseInt(this.total / 10) + 1;
        }
      }
    }
  }
};
</script>

<style scoped>
.newsFlex {
  width: 1200px;
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.newsFlex .flexItem {
  background-color: #fff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  padding: 0 24px;
  padding-top: 8px;
  padding-bottom: 30px;
}

.newsFlex .classTJ {
  display: inline-block;
  margin-left: 20px;
  background-color: #fff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  padding: 20px;
}

.newsFlex .classTJ .TuijianTitle {
  color: #003399;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 4px solid #003399;
  margin-bottom: 23px;
}

.newsFlex .classTJ .TuijianItem {
  display: block;
  width: 280px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  font-size: 0;
  margin-bottom: 20px;
  padding-bottom: 23px;
}

.newsFlex .classTJ .TuijianItem .avatar {
  width: 100%;
  height: 160px;
  object-fit: cover;
  margin-bottom: 14px;
}

.newsFlex .classTJ .TuijianItem .name {
  display: block;
  color: #151515;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 14px;
  padding-left: 24px;
  padding-right: 24px;
}

.newsFlex .classTJ .TuijianItem .desc {
  display: block;
  padding-left: 24px;
  padding-right: 24px;
  color: #737373;
  font-size: 12px;
}

.newsFlex .classTJ .TuijianItem:hover .name {
  color: var(--link-hover-color);
}

.newsFlex .newsItem {
  border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
  padding-top: 24px;
  padding-bottom: 24px;
}

.newsFlex .newsItem .pic {
  display: inline-block;
  width: 170px;
  height: 116px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 16px;
}

.newsFlex .newsItem .flexItem {
  position: relative;
  padding: 0;
  box-shadow: initial;
}

.newsFlex .newsItem .flexItem h6 {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.newsFlex .newsItem .flexItem .desc {
  color: #333;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.newsFlex .newsItem .flexItem .date {
  display: block;
  color: #666;
  font-size: 12px;
  line-height: 22px;
  position: absolute;
  left: 0;
  top: 97px;
}

.newsFlex .newsItem:hover .flexItem h6 {
  color: var(--link-hover-color);
}

.newsFlex .article {
  padding: 32px 40px;
  padding-bottom: 50px;
}

.newsFlex .article .articleHeader {
  border-bottom: 1px solid #f2f3f5;
  padding-bottom: 24px;
}

.newsFlex .article .articleHeader h2 {
  color: #222;
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 13px;
}

.newsFlex .article .articleHeader h6 {
  color: #818993;
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
}

.newsFlex .article .cont {
  padding-top: 24px;
}

.newsFlex .article .cont p {
  color: #333;
  font-size: 16px;
  line-height: 28px;
  text-indent: 0;
  margin-bottom: 30px;
}

.newsFlex .article .cont img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}

.layui-laypage {
  margin-top: 20px;
}
.layui-laypage button {
  display: inline-block;
  height: 36px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  line-height: 36px;
  margin-right: 10px;
}
.layui-laypage button:hover {
  color: var(--link-hover-color);
}
.layui-laypage button:disabled {
  color: lightgray;
}
</style>